import { FaRegFlag } from 'react-icons/fa'
import { MdOutlineStickyNote2 } from 'react-icons/md'
import { TbMessage2Exclamation } from 'react-icons/tb'

export const NO_FLAGS_FOUND = 'No Flags'
export const NO_TASKS_FOUND = 'No Tasks'
export const NO_NOTES_FOUND = 'No Notes'
export const NO_CFB_FOUND = 'No CFBs'
export const NO_FLAGS_AVAILABLE = 'No flags available'

export const ACTIVE_FLAG_OPACITY = 1
export const INACTIVE_FLAG_OPACITY = 0.2

export const flagIconMap: Record<string, React.ComponentType> = {
    task: FaRegFlag,
    note: MdOutlineStickyNote2,
    cfb: TbMessage2Exclamation,
}

export enum FLAG_FILTER_TAB_OPTIONS {
    ALL = 'all',
    TASK = 'task',
    NOTE = 'note',
    CFB = 'cfb',
}

export enum TEXT_EDITOR_MODES {
    FLAG_CREATION = 'flag_creation',
    FLAG_COMMENT_CREATION = 'flag_comment_creation',
    FLAG_COMMENT_EDIT = 'flag_comment_edit',
}

export enum FLAG_MODAL_CONFIRMATION_TYPES {
    DELETE_FLAG = 'delete_flag',
    DELETE_COMMENT = 'delete_comment',
    DELETE_COMMENT_DRAFT = 'delete_comment_draft',
    CLEAR_EDIT_COMMENT_DRAFT = 'clear_edit_comment_draft',
}

export const FLAG_MODAL_CONFIRMATION_MESSAGES: Partial<Record<FLAG_MODAL_CONFIRMATION_TYPES, string>> = {
    [FLAG_MODAL_CONFIRMATION_TYPES.DELETE_COMMENT]: 'Are you sure you want to delete this comment?',
    [FLAG_MODAL_CONFIRMATION_TYPES.DELETE_COMMENT_DRAFT]: 'Are you sure you want to delete this draft?',
    [FLAG_MODAL_CONFIRMATION_TYPES.CLEAR_EDIT_COMMENT_DRAFT]: 'Are you sure you want to clear any unsaved changes?',
}

export const getFlagModalConfirmationMessage = (
    type: FLAG_MODAL_CONFIRMATION_TYPES,
    flagNumber?: number,
    flagType?: string
): string => {
    if (type === FLAG_MODAL_CONFIRMATION_TYPES.DELETE_FLAG && flagNumber !== undefined) {
        const typeLabel = flagType ? ` ${flagType}` : ''

        return `Delete ${typeLabel} flag #${flagNumber}? This will permanently remove all instances of this flag and delete all associated comments. This cannot be undone.`
    }

    return FLAG_MODAL_CONFIRMATION_MESSAGES[type] || ''
}

export enum FLAG_FORM_INPUT_FIELD_TYPES {
    SUBMITTER_NAME = 'submitter_name',
    DESCRIPTION = 'description',
}
